// src/store/modules/partners.js
import {api} from "@/middleware/api";

export const partners = {
    namespaced: true,

    state: () => ({
        partners: []
    }),

    getters: {
        getById: (state) => (id) => {
            return state.partners.find(p => p.id === Number(id));
        }
    },

    mutations: {
        SET_PARTNERS: (state, payload) => {
            state.partners = payload;
        },
        ADD_PARTNER(state, partner) {
            state.partners.push(partner);
        },
        UPDATE_PARTNER(state, updatedPartner) {
            const index = state.partners.findIndex(p => p.id === updatedPartner.id);
            if (index !== -1) {
                state.partners.splice(index, 1, updatedPartner);
            }
        },
        REMOVE_PARTNER(state, id) {
            state.partners = state.partners.filter(p => p.id !== id);
        }
    },

    actions: {
        async fetchPartners({ commit }) {
            const {data} = await api.dashboard.adminPartnersControllerFindAll()
            commit('SET_PARTNERS', data.items)
        },
        addPartner({ commit }, partner) {
            commit('ADD_PARTNER', partner);
        },
        updatePartner({ commit }, updatedPartner) {
            commit('UPDATE_PARTNER', updatedPartner);
        },
        async deletePartner({ commit }, id) {
            await api.dashboard.adminPartnersControllerRemove(id)
            commit('REMOVE_PARTNER', id);
        }
    }
};
